import { useEffect, useState } from 'react';
import type { GameId, RoleId } from '@ringmaster/shared';
import { HoloRoleCard } from './HoloRoleCard.js';
import { roleCardBackFor, roleCardDefFor } from './roleCardDefs.js';

/**
 * PeekRevealCard — a compact {@link HoloRoleCard} for PASSIVE reveals: a
 * peeked centre card, a peeked player's card, or a Thief's stolen card. The
 * role is already known (the private view carries it) so there is nothing to
 * hold for — the card mounts face-down and flips itself open a beat later,
 * so the moment still reads as "the card turning over" (HoloRoleCard's own
 * flip animation, which already honours prefers-reduced-motion) instead of a
 * Glyph icon + text label. Used by both Blood Moon: One Night's centre-peek
 * reveals (hand/OneNightScreens.tsx + discord/desktop/screens/OneNightContent.tsx)
 * and the Thief's stolen-card reveal in the swap screens — never fork this,
 * both surfaces import it so phone and desktop stay in lockstep.
 */
export function PeekRevealCard({
  role,
  gameId = 'onenight',
  width = 'min(150px, 38vw)',
  delayMs = 150,
}: {
  role: RoleId;
  gameId?: GameId;
  width?: string;
  delayMs?: number;
}) {
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setShown(true), delayMs);
    return () => clearTimeout(t);
  }, [delayMs]);
  return (
    <HoloRoleCard
      def={roleCardDefFor(gameId, role)}
      backSrc={roleCardBackFor(gameId)}
      revealed={shown}
      width={width}
    />
  );
}
